import css from './wordListList.module.scss';

import { memo } from 'react';

import WordListItem from 'com/WordListItem';
import Preloader from 'core/ui/Preloader';
import Waypoint from 'core/ui/Waypoint';

import useWordList from './useWordList';

const WordListList = (props: ReturnType<typeof useWordList>) => {
  const { words, deck, onChangeWord, onRemoveWord, isFetching, fetchMore } =
    props;

  return (
    <div className={css.list}>
      {deck &&
        words.map(word => (
          <WordListItem<TWord>
            key={word.uid}
            deck={deck}
            word={word}
            onChangeWord={onChangeWord}
            onRemoveWord={onRemoveWord}
          />
        ))}
      <Waypoint onTrigger={fetchMore} />
      {isFetching && (
        <div className={css.preloaderWrapper}>
          <Preloader />
        </div>
      )}
      {!isFetching && !words.length && 'Nothing has been found :('}
    </div>
  );
};

export default memo(WordListList);
